import TextImageSlideBody from "../components/carousel/slide-item/text-image-slide-body/TextImageSlideBody";
import TextSlideBody from "../components/carousel/slide-item/text-slide-body/TextSlideBody";
import ImageTitleBody from "../components/carousel/slide-item/image-title-body/ImageTitleBody";
import { email, secure, expert } from "@limitless/images";
const TEXT_SLIDE = "text";
export const TEXT_IMAGE_SLIDE = "text/image";
const IMAGE_TITLE_SLIDE = "image/title";
const SLIDE_BODY_MAP = {
  [TEXT_IMAGE_SLIDE]: TextImageSlideBody,
  [TEXT_SLIDE]: TextSlideBody,
  [IMAGE_TITLE_SLIDE]: ImageTitleBody
};
export const HIW_CARD_TYPES = [{
  label: "Headline, Image, Title",
  value: TEXT_IMAGE_SLIDE
}, {
  label: "Text Only",
  value: TEXT_SLIDE
}, {
  label: "Image, Title, Headline",
  value: IMAGE_TITLE_SLIDE
}];
export const getSlideBodyComponent = type => {
  let SlideBody = SLIDE_BODY_MAP[type];
  //if the type is missing or not set, use text image slide
  SlideBody = SlideBody ? SlideBody : SLIDE_BODY_MAP[TEXT_IMAGE_SLIDE];
  return SlideBody;
};
export const getDefaultHIWSlides = () => {
  return [{
    id: 1,
    title: "How it Works",
    imgSrc: expert,
    headline: "Experts are customers like you. They love helping people, are passionate about products and are quick to share useful information",
    buttonText: "Get Started",
    primaryColour: "#0050FF",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }, {
    id: 2,
    title: "How it Works",
    imgSrc: secure,
    headline: "They are NOT employees so please do not share any personal or account information with your Experts ",
    buttonText: "Get Started",
    primaryColour: "#B65C11",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }, {
    id: 3,
    title: "How it Works",
    imgSrc: email,
    headline: "Provide your email address and receive instant notifications when Experts respond",
    buttonText: "Get Started",
    primaryColour: "#663FC0",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }];
};